import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import Repeater from '@Utils/Repeater';
import { TeamArmyView } from '@Selectors/tool/pairing/create/view/TeamArmyView';
import Card from '../components/draft/utils/Card';
import { CardDisplay } from '../components/draft/utils/CardDisplay';
import { FormattedMessage } from 'react-intl';

const ReduxFormTeamArmyBlock: React.FC = (field: any) => (
  <div>
    {field.label && (<Label><FormattedMessage {...field.label} /></Label>)}
    <FormGroup row={true} className="justify-content-center list-armies">
      <Repeater data={field.datas} indexPrefix='teamArmy'>
        {
          (item: TeamArmyView, index: number) =>
            <Card display={item.armyId > 0 ? CardDisplay.ARMY_EDIT : CardDisplay.DEFAULT}
                  selectable={item.selectable}
                  army={item}
                  selected={item.selected}
                  select={() => field.unselectArmy(field.datas, item)}
                  setName={(name: string) => field.updatePlayerName(field.datas, index, name)}/>
        }
      </Repeater>
    </FormGroup>
    {field.meta.touched && field.meta.error && (
      <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
    )}
  </div>
);

export default ReduxFormTeamArmyBlock;